<template>
    <div class="main-container" id="anchor-videos">
        <div
            class="videos-section">
            <h2>{{ $t("press.videosSection.videos").toUpperCase() }}</h2>
            <div class="gallery-wrapper">
                <Gallery
                    :thumbnails="videos.thumbnails"
                    :thumbnails-path="videos.thumbnailsPath"
                    :captions="videos.captions"
                    :youtube-id="videos.youtubeId"
                    :dimension="{ width: 330, height: 237 }"
                    :grid-desktop="true"
                    :youtube="true"
                    class="videos" />
            </div>
        </div>
    </div>
</template>

<script>
import Gallery from '@/components/press/Gallery.vue'
import imageVideo7 from '@/static/img/videos/imageVideo7.png'

export default {
    components: {
        Gallery
    },
    computed: {
        pressKitLink () {
            return 'https://presskit.sandbox.game/'
        },
        translate () {
            return {
                videoDescription: [
                    this.$t('press.videosSection.videosDescription1'),
                    this.$t('press.videosSection.videosDescription2'),
                    this.$t('press.videosSection.videosDescription3'),
                    this.$t('press.videosSection.videosDescription4'),
                    this.$t('press.videosSection.videosDescription5'),
                    this.$t('press.videosSection.videosDescription6'),
                    this.$t('press.videosSection.videosDescription7'),
                    this.$t('press.videosSection.videosDescription8'),
                    this.$t('press.videosSection.videosDescription9')
                ]
            }
        },
        videos () {
            return {
                thumbnailsPath: 'https://presskit.sandbox.game/VideoThumbnails/',
                thumbnails: [
                    {
                        image: 'Pillars_Of_The_Sandbox.png',
                        description: this.translate.videoDescription[0],
                        download: this.pressKitLink + 'Pillars_Of_The_Sandbox.mp4'
                    },
                    {
                        image: 'Islands_In_The_Sky.png',
                        description: this.translate.videoDescription[1],
                        download: this.pressKitLink + 'Islands_In_The_Sky.mp4'
                    },
                    {
                        image: 'Model_Animate_Play.png',
                        description: this.translate.videoDescription[2],
                        download: this.pressKitLink + 'Model_Animate_Play.mp4'
                    },
                    {
                        image: 'Creating_A_Canyon.png',
                        description: this.translate.videoDescription[3],
                        download: this.pressKitLink + 'Creating_A_Canyon_Experience.mp4'
                    },
                    {
                        image: 'Virtual_Concert.png',
                        description: this.translate.videoDescription[4],
                        download: this.pressKitLink + 'Virtual_Concert.mp4'
                    },
                    {
                        image: 'Make_A_Game_With_Atari_NFTs.png',
                        description: this.translate.videoDescription[5],
                        download: this.pressKitLink + 'Make_A_Game_With_Atari_NFTs.mp4'
                    },
                    {
                        image: imageVideo7,
                        description: this.translate.videoDescription[5],
                        download: this.pressKitLink + 'Make_A_Game_With_Atari_NFTs.mp4'
                    }
                ],
                youtubeId: [
                    'HRYB9CvQMiA',
                    'uDkf1CrkF7Y',
                    'y9XACGNQjGs',
                    'FpM8kT9dUNg',
                    'VaihWTEHb_E',
                    'PD-y2_Wpiig',
                    'wQdV03k_4xA'
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
  .main-container {
    padding: 100px 0px;
    background-color: $gray3;
    @include breakpoint($device: mobile) {
        padding: 80px 0px;
    }
    a {
      text-decoration: none;
      color: $blue-2 !important;
      font-weight: 600;
    }
    p {
        margin-bottom: 0;
    }
    @include breakpoint($min: desktop-sm) {
      & > div:not(:first-child) {
        margin: auto;
        max-width: 75vw;
      }
    }
    .top-section {
      .sandbox-brand-page:before {
        content: "";
        position: absolute;
        z-index: -1;
        opacity: 0.4;
        width: 100%;
        height: 100%;
        background: url("https://presskit.sandbox.game/Biome_Jungle.jpg")
          no-repeat 0 0;
        background-size: cover;
      }
      .sandbox-brand-page {
        @include flex(column, center, center);
        position: relative;
        z-index: -2;
        height: 200px;
        max-height: 200px;
        margin-top: 60px;
        .title {
          color: white;
          margin-top: 60px;
          font-size: 70px;
          font-family: "Montserrat Bold";
        }
        p {
          padding: 0px 200px 50px 200px;
          text-align: center;
          font-size: 21px;
        }
      }
    }
    .videos-section {
      @include flex(column, center, center);
      width: 100%;
      h2 {
        font-size: 50px;
        font-weight: Bold;
      }
      .gallery-wrapper {
        margin-top: 3vh;
        & > div {
          & > div {
            figure {
              img {
                border-radius: 10px;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
@include breakpoint($device: touch) {
  .main-container {
    scroll-behavior: smooth;
    .top-section {
      .top-bar {
        display: none;
      }
      .sandbox-brand-page:before {
        content: "";
        position: absolute;
        z-index: -1;
        opacity: 0.4;
        width: 100%;
        height: 100%;
        background: url("https://presskit.sandbox.game/Biome_Jungle.jpg")
          no-repeat 0 0;
        background-size: cover;
      }
      .sandbox-brand-page {
        @include flex(column, center, center);
        position: relative;
        z-index: -2;
        height: 148px;
        .title {
          color: white;
          margin-top: 20px;
          font-size: 25px;
          font-family: "Montserrat Bold";
        }
        p {
          text-align: center;
          margin-top: 20px;
          font-size: 12px;
        }
      }
    }
    .videos-section {
      @include flex(column, center, center);
      margin-right: 20px;
      h2 {
        font-size: 25px;
        font-weight: Bold;
      }
    }
  }
}
</style>
